import { ClientDataType } from '../types';

export const ANON_EVENTS = [ClientDataType.AnonSession];
export const EMBEDDED_EVENTS = [
  ClientDataType.EmbeddedClick,
  ClientDataType.EmbeddedReceived,
  ClientDataType.EmbeddedImpression,
  ClientDataType.EmbeddedSession,
];

export const WHATS_APP_EVENTS = [
  ClientDataType.WhatsAppBounce,
  ClientDataType.WhatsAppClick,
  ClientDataType.WhatsAppConversationOpened,
  ClientDataType.WhatsAppDelivery,
  ClientDataType.WhatsAppReceived,
  ClientDataType.WhatsAppSeen,
  ClientDataType.WhatsAppSend,
  ClientDataType.WhatsAppSendSkip,
  ClientDataType.WhatsAppUsageInfo,
];

// Events in this list will be excluded from the segmentation page in the UI.
export const EXCLUDED_WHATSAPP_EVENTS = [
  ClientDataType.WhatsAppConversationOpened,
  ClientDataType.WhatsAppDelivery,
];

export const JOURNEY_EXIT_EVENTS = [ClientDataType.JourneyExit];
